import React, { useLayoutEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import Logo from '../ASSETS/PermutileLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import { HELP_PAGE, SKILL_PAGE, MODE_AI, MODE_SOLO, MODE_FRIEND } from '../../HOME/const';
import { SET_MODE, SET_SKILL, SET_OPTIONS } from '../REDUX/actions';
import { getAppInfo } from '../../HOME/info';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';
import { OPTIONS_KEY, CLUES_PAGE } from '../../PT/const';
import HumanIcon from '../COMPONENTS/HumanIcon';
import RobotIcon from '../COMPONENTS/RobotIcon';
import HelpIcon from '../COMPONENTS/HelpIcon';
import { PN_RED, PN_YELLOW, PN_GREEN, PN_PURPLE, PN_BLUE } from '../../PN/const';
import * as f from '../logic';

const StartPage = () => {
  const dispatch = useDispatch();
  const { common } = useSelector(state => state);
  const [dummy, setDummy] = useState(false);
  const [mode, setMode] = useState(null);

  useLayoutEffect(() => {
    const forceUpdate = () => setDummy(!dummy);
    window.addEventListener('resize', forceUpdate);

    dbget(OPTIONS_KEY, options => {
      dispatch({ type: SET_OPTIONS, options });
    });

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [dummy, dispatch]);

  const handleMode = () => {
    if (mode === 'HELP') {
      dispatch({ type: GOTO_PAGE, payload: { page: HELP_PAGE } });
      return;
    }

    dispatch({ type: SET_MODE, mode });

    if (mode !== MODE_AI) {
      dispatch({ type: SET_SKILL, skill: 0 });
    }

    dispatch({ type: GOTO_PAGE, payload: { page: mode === MODE_AI ? SKILL_PAGE : CLUES_PAGE } });
  };

  const pulseString = useSpring({
    to: { transform: `scale(${mode ? 0.75 : 1})` },
    onRest: () => mode && handleMode(),
    config: { duration: 200 },
  });

  const { x: wx, y: wy } = windowSize();
  const width = Math.min(wx, wy) / 7;
  const appName = getAppInfo(common.app).name;

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <img src={Logo} width={width} alt="Permutile logo" style={{ margin: '0 1em' }} />
        {f.renderTitle(appName, 'mt-title pt-title')}
      </div>
      <div className="pt-page" style={{ backgroundImage: GradientBackground }}>
        {_.map(['HELP', MODE_AI, MODE_SOLO, MODE_FRIEND], op => {
          const gridArea = op === MODE_AI ? '1/2' : op === MODE_SOLO ? '2/1' : op === MODE_FRIEND ? '2/2' : '1/1';
          const style = op === mode ? pulseString : {};
          return (
            <animated.div key={op} className="pt-start-option" style={{ ...style, gridArea, display: 'grid' }} onClick={() => setMode(op)}>
              {op === MODE_AI ? (
                <>
                  <RobotIcon width="50px" color={PN_RED} style={{ gridArea: '1/1', transform: 'translate(10px,-5px)' }} />
                  <HumanIcon width="50px" color={PN_GREEN} style={{ gridArea: '1/1', transform: 'translate(-10px,5px)' }} />
                </>
              ) : op === MODE_SOLO ? (
                <HumanIcon width="60px" color={PN_YELLOW} style={{ gridArea: '1/1' }} />
              ) : op === MODE_FRIEND ? (
                <>
                  <HumanIcon width="50px" color={PN_PURPLE} style={{ gridArea: '1/1', transform: 'translate(10px,-5px)' }} />
                  <HumanIcon width="50px" color={PN_BLUE} style={{ gridArea: '1/1', transform: 'translate(-10px,5px)' }} />
                </>
              ) : (
                <HelpIcon width="60px" style={{ gridArea: '1/1', transform: 'scale(0.9)' }} />
              )}
            </animated.div>
          );
        })}
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default StartPage;
